/**
 * First-paint loader baked into index.html (`#app-loader`). It is dismissed once
 * the app shell has mounted: two animation frames let the freshly-rendered shell
 * paint before the loader fades, avoiding a flash-to-blank.
 */
export const APP_LOADER_FADE_MS = 300;

export function dismissAppLoader(doc: Document = document): void {
  const loader = doc.querySelector("#app-loader");
  if (!loader) {
    return;
  }
  loader.classList.add("app-loader--hidden");
  setTimeout(() => {
    loader.remove();
  }, APP_LOADER_FADE_MS);
}

export function scheduleAppLoaderDismiss(doc: Document = document): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => dismissAppLoader(doc));
  });
}
